import { render, staticRenderFns } from "./SuggestionsSelect.vue?vue&type=template&id=71c2de97&"
import script from "./SuggestionsSelect.vue?vue&type=script&lang=js&"
export * from "./SuggestionsSelect.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionsSelect.vue?vue&type=style&index=0&id=71c2de97&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports